module.exports = __webpack_public_path__ + "c55d425486ae6b011308f5dd8c90e9dd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/kloudless/icons/box.png
 ** module id = 1475
 ** module chunks = 0
 **/